/**
 * 테마·스타일 이름 다국어 필드 공통 헬퍼.
 * 평면 필드(name/nameEn/nameJa/nameZh) 구조 — 기존 AIStyle 의 name/nameEn 과 호환되며
 * DynamoDB 기존 항목 마이그레이션이 필요 없다. 미입력 언어는 ko(name) 로 폴백.
 */
/** 지원 언어 코드 목록. 순서: ko → en → ja → zh. */
export const LOCALE_CODES = ["ko", "en", "ja", "zh"];
/** 키오스크·콘솔의 기본 언어. */
export const DEFAULT_LOCALE = "ko";
/**
 * 헤더 세그먼트 라벨 — 손님이 자기 언어를 바로 알아보게 네이티브 언어명 (2026-10-21, 이전엔 KR·EN·JP·CN 약어).
 * 키오스크 헤더 및 콘솔 셀렉트에서 공용으로 사용한다.
 */
export const LOCALE_LABELS = {
    ko: "한국어",
    en: "English",
    ja: "日本語",
    zh: "中文",
};
/** `v` 가 지원 `LocaleCode` 중 하나이면 true. 대문자·지역 접미·빈 문자열·비문자열은 false. */
export function isLocaleCode(v) {
    return LOCALE_CODES.includes(v);
}
/**
 * 부스의 `defaultLanguage` 를 `LocaleCode` 로 해석한다.
 * 값이 유효한 `LocaleCode` 면 그 값, 없거나 빈 문자열이거나 모르는 코드면 `DEFAULT_LOCALE`("ko").
 */
export function resolveDefaultLanguage(booth) {
    return isLocaleCode(booth?.defaultLanguage) ? booth.defaultLanguage : DEFAULT_LOCALE;
}
/** 언어에 맞는 이름을 돌려준다. 해당 언어 값이 비어 있으면 ko 폴백. */
export function localizedName(fields, language) {
    const pick = (v) => (v && v.trim() ? v : fields.name);
    switch (language) {
        case "en":
            return pick(fields.nameEn);
        case "ja":
            return pick(fields.nameJa);
        case "zh":
            return pick(fields.nameZh);
        default:
            return fields.name;
    }
}
/** 언어에 맞는 설명을 돌려준다. 해당 언어 값이 비어 있으면 ko(description) 로 폴백. */
export function localizedDescription(fields, language) {
    const pick = (v) => (v && v.trim() ? v : fields.description);
    switch (language) {
        case "en":
            return pick(fields.descriptionEn);
        case "ja":
            return pick(fields.descriptionJa);
        case "zh":
            return pick(fields.descriptionZh);
        default:
            return fields.description;
    }
}
/**
 * 생성 화면 소개 문구 — **해당 언어 값만** 돌려준다. 비어 있거나 공백만이면 "" (키오스크는 단락을 렌더하지 않음).
 * 이름·설명과 달리 ko 폴백도 description 폴백도 두지 않는다 — 운영자가 언어별로 넣은 문구만 그 언어에서 보이게
 * 하려는 결정(2026-09-14). 줄바꿈은 그대로 보존한다(키오스크 `<Lines/>`).
 */
export function localizedStory(fields, language) {
    const v = language === "en" ? fields.storyEn : language === "ja" ? fields.storyJa : language === "zh" ? fields.storyZh : fields.story;
    return v && v.trim() ? v : "";
}
//# sourceMappingURL=i18n.js.map